<!--
Displays a Out of Service message with custom content.
Usage: <OutOfService text="some text" />
@author crm4f
-->
<template>
    <div class="oosContainer">
      <img id='maintainanceImg' :src="maintenanceImg"/>
      {{text}}
    </div>
</template>

<script>
import maintenanceImg from '@/assets/maintenance.svg'
export default {
  name: 'OutOfService',
  props: {
    text: String
  },
  data () {
    return {
      maintenanceImg
    }
  },
  mixins: [],
  methods: {
  }
}
</script>

<style>
.oosContainer {
    border-radius: 24px;
    background: #ffffff;
    margin-left:5%;
    margin-right:5%;
    margin-bottom: 24px;
    padding: 20px;
    padding-bottom:36px;
    color: #003865;
    display: flex;
    flex-flow: column wrap;
    text-align: center;
}
</style>
